import styled from "styled-components";
import { device } from "../../utils/helperFunctions";

export const HeaderWrapper = styled.div`
  height: 90px;
  position: fixed;
  top: 0;
  width: calc(100% - 120px);
  background-color: #000;
  z-index: 9999;
  padding: 14px 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media ${device.tablet} {
    height: 70px;
    padding: 14px 36px;
    width: calc(100% - 72px);
  }
`;

export const LogoWrapper = styled.div`
  width: 132px;
  height: 63px;

  @media ${device.tablet} {
    width: 110px;
    height: 60px;
  }
`;

export const GoBackWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export const BackArrowWrapper = styled.div`
  width: 36px;
  height: 36px;

  @media ${device.tablet} {
    width: 24px;
    height: 24px;
  }
`;

export const BackHomeLabel = styled.div`
  font-weight: 400;
  font-size: 24px;
  color: #fff;
  line-height: 18px;
  margin-left: 12px;

  @media ${device.tablet} {
    font-size: 18px;
  }
`;

export const ToggleButtonWrapper = styled.div`
  height: 90px;
  display: flex;
  align-items: center;
  background-color: #383838;
  border-radius: 57px;

  @media ${device.tablet} {
    height: 70px;
  }
`;

export const ToggleButtonContainer = styled.div`
  height: 70px;
  display: flex;
  border-radius: 57px;
  padding: 0px 15px;
  align-items: center;
`;

export const ToggleButtonLabelText = styled.div`
  font-weight: 700;
  font-size: 24px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--text-primary);

  @media ${device.tablet} {
    font-size: 18px;
  }
`;

export const StartOverContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  gap: 32px;
`;

export const StartOverIconWrapper = styled.div`
  height: 24px;
  width: 24px;

  @media ${device.tablet} {
    height: 20px;
    width: 20px;
  }
`;

export const StartOverLabelText = styled.div`
  font-weight: 600;
  font-size: 24px;
  color: var(--text-secondary);

  @media ${device.tablet} {
    font-size: 20px;
  }
`;

export const SelectedDeliveryOptionText = styled.div`
  font-weight: 700;
  font-size: 32px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--text-secondary);

  @media ${device.tablet} {
    font-size: 24px;
  }
`;
